import { DataHeader, DataSource, HorizontalSpacer, Layout, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTruckSearch extends Layout {
    dataheader1: DataHeader;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    mainTabset: Tabset;
    sourceLoadBoardService: DataSource;
    sourcePnnTranscoreUser: DataSource;
    switchIsActive: Switch;
    tabGeneral: Tab;
    tabUsers: Tab;
    tablePnnTranscoreUsers: Table;
    textboxAddress: Textbox;
    textboxPasswd: Textbox;
    textboxPort: Textbox;
    textboxServiceName: Textbox;
    textboxUserid: Textbox;
}
